<div id="overlay-panel-action" class="overlay-dock">
    <div *ngIf="field" (click)="panel.toggle($event)">
      {{field | customShortenText:maxLength}}
    </div>
</div>



<p-popover #panel *ngIf="field"
    [dismissable]="true"
    [showCloseIcon]="true"
    [appendTo]="'body'"
    >

    <div class="p-popover-content">
        {{field}}
    </div>

</p-popover>
